import classNames from 'classnames'
import React from 'react'
import {Button, ButtonPriority} from 'wix-ui-tpa/cssVars'
import {classes} from './join-button.st.css'
import {JoinButtonProps} from './index'

export const JoinButton: React.FC<JoinButtonProps> = ({className, onClick, dataHook, children}) => (
  <Button
    upgrade
    priority={ButtonPriority.secondary}
    className={classNames(classes.root, className)}
    onClick={onClick}
    data-hook={dataHook}
  >
    {children}
  </Button>
)
